import Device from './Device';

export default class DeviceType {
  static get isTizen() {
    return !!window.tizen;
  }

  static get isLG() {
    // Schnelle, synchrone UA-Erkennung. Die inline-Erkennung in index.html
    // setzt window.isLG / window.lgVersion / window.webos bereits beim
    // HTML-Parsing; hier steht nur ein Fallback, falls externe Scripts die
    // Inline-Erkennung verzoegert haben.
    if (window.isLG === true) return true;
    if (window.isLG === false) return false;
    var ua = (window.navigator && window.navigator.userAgent) || '';
    var detected = !window.tizen && (ua.indexOf("LGE") > 0 || ua.indexOf("WebOS") > 0 || ua.indexOf("webOS") > 0 || ua.indexOf("STB-") > 0);
    window.isLG = detected;
    if (detected) {
      if (!window.webos) window.webos = DeviceType._webOSFromUA(ua);
      if (!window.lgVersion) window.lgVersion = window.webos || (ua.indexOf("STB-5500") > 0 ? '3.5' : '5.0');
    }
    return detected;
  }

  // Chrome-Version -> webOS-Generation (LG-dokumentierte Zuordnung).
  // Hospitality-Modell STB-5500 ist fix webOS 3.5.
  static _webOSFromUA(ua) {
    if (!ua) return null;
    if (ua.indexOf("STB-5500") > 0) return '3.5';
    var m = ua.match(/Chrome\/(\d+)/);
    if (!m) return null;
    var c = parseInt(m[1], 10);
    if (c >= 108) return '23';
    if (c >= 94)  return '22';
    if (c >= 87)  return '6.0';
    if (c >= 79)  return '5.0';
    if (c >= 68)  return '4.5';
    if (c >= 53)  return '4.0';
    if (c >= 38)  return '3.0';
    if (c >= 34)  return '2.0';
    return '1.0';
  }

  // Liefert die WebOS-Version synchron aus window.webos oder UA-Fallback.
  static get getWebOSVersion() {
    if (window.webos) return window.webos;
    if (!this.isLG) return null;
    var ua = (window.navigator && window.navigator.userAgent) || '';
    window.webos = DeviceType._webOSFromUA(ua);
    return window.webos;
  }

  // Verfeinert window.webos mittels nativer APIs, sobald diese bereit sind.
  // - Consumer-TVs: webOS.deviceInfo({sdkVersion, version, modelName})
  // - Hospitality: hcap.API_VERSION
  // Faellt still zurueck, wenn keine API verfuegbar ist.
  static refineWebOSVersion() {
    try {
      if (typeof hcap !== 'undefined' && hcap && hcap.API_VERSION) {
        window.hcapApiVersion = String(hcap.API_VERSION);
      }
      if (typeof webOS !== 'undefined' && webOS && typeof webOS.deviceInfo === 'function') {
        webOS.deviceInfo(function(info) {
          if (info && (info.sdkVersion || info.version)) {
            window.webos = String(info.sdkVersion || info.version);
            window.webosDeviceInfo = info;
          }
        });
      }
    } catch (e) {
      console.log('refineWebOSVersion error', e);
    }
    return window.webos || null;
  }
  static get isOrsay() {
    if(window.isOrsay === true) return true;
    if(window.isOrsay === false) return false;
    return !!window.orsay;
  }
  static get isRPI() {
    // let socketio = io('http://127.0.0.1:4000/');
    // if (socketio)
    if (window.io) return true;
    return false;
  }
  static get isBrowser() {
    return !this.isTizen && !this.isLG && !this.isRPI && !isOrsay;
  }
  static get getDeviceType() {
    if (this.isTizen) return 'tv-tizen';
    if (this.isOrsay) return 'tv-orsay';
    if (this.isLG) return 'tv-lge';
    if (this.isRPI) return 'tv-rpi';
    return 'tv-default';
  }

  static get getUserAgent() {
    if (!window.navigator) return '';
    return window.navigator.userAgent;
  }

  static get getDeviceModel() {
    return Device.model;
  }

  static get getDeviceSoftware() {
    return Device.software;
  }

  static get getMAC() {
    //return '00:00:00:00:00:00';
    return Device.mac;
  }

  static get getIP() {
    //return '0.0.0.0';
    return Device.ip;
  }

  static get getSerial() {
    //console.log("======================================================getSERIAL_0", webapis.systemcontrol.getSerialNumber());
    return Device.serialNumber;
  }

  static get getResHeight() {
    return Device.resolutionHeight;
  }

  static get getResWidth() {
    return Device.resolutionWidth;
  }

  static async getDefaultDevice() {
    const [model, version, software, mac, ip, serialNumber, platform, resHeight, resWidth] = await Promise.all([
      Device.model,
      Device.version,
      Device.firmware,
      Device.mac,
      Device.ip,
      Device.serialNumber,
      Device.platform,
      Device.resolutionHeight,
      Device.resolutionWidth,
    ]);

    const device = {
      buildingId: null,
      groupId: null,
      type: this.getDeviceType,
      agent: this.getUserAgent,
      updated: Math.floor(new Date().getTime() / 1000),
      model,
      version,
      software,
      mac,
      ip,
      serialNumber,
      platform,
      resHeight,
      resWidth,
    };
    console.log('=====================================getDefaultDevice', device);
    return device;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/DeviceType.js